import React from "react";

import AudioPlayer from "../AudioPlayer";
import {PodcastWrap, ListenHere, ListenOn, PodcastLink, PodcastLinksRow} from "./elements";
import {TitleSm} from "../elements";
import PodcastArrow from "../../assets/icons/ArrowIcon";

function PodcastBlock({audioAsset,googlePodcastLink,applePodcastLink,spotifyPodcastLink}) {

   
    return (
        <PodcastWrap>
            <ListenHere>
                <TitleSm textTransform={"uppercase"} margin={"0 0 25px 0"}>Listen here</TitleSm>
                <AudioPlayer source={audioAsset} />
            </ListenHere>
            <ListenOn>
                <TitleSm textTransform={"uppercase"} margin={"0 0 40px 0"}>or Listen on</TitleSm>
                <PodcastLinksRow>
                    {spotifyPodcastLink && (
                        <PodcastLink href={spotifyPodcastLink} target="_blank">
                            Spotify
                            <PodcastArrow />
                        </PodcastLink>
                    )}
                    {applePodcastLink && (
                        <PodcastLink href={applePodcastLink} target="_blank">
                            Apple Podcasts
                            <PodcastArrow />
                        </PodcastLink>
                    )}
                    {googlePodcastLink && (
                        <PodcastLink href={googlePodcastLink} target="_blank">
                            Google Podcasts
                            <PodcastArrow />
                        </PodcastLink>
                    )}
            
                </PodcastLinksRow>
            </ListenOn>
        </PodcastWrap>
)
}

export default PodcastBlock;
